module.exports = __webpack_public_path__ + "static/media/personal_lastname.12a5e2ae.svg";